/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SELECTED_REBATE_PROGRAM = 'SELECTED_REBATE_PROGRAM';
export const ASSIGN_DISPUTE_DETAIL = 'ASSIGN_DISPUTE_DETAIL';
export const ERROR_LIST = 'ERROR_LIST';
export const REBATE_PROGRAM_LIST = 'REBATE_PROGRAM_LIST';
export const MANUFACTURER_LIST = 'MANUFACTURER_LIST';
export const RESET_STATE = 'RESET_STATE';
export const CHECK_FLAG = 'CHECK_FLAG';
export const GET_PLAN_TYPE = 'GET_PLAN_TYPE';
export const FIRST_LOAD = 'FIRST_LOAD_AD';
